import permissions from '@enums/user-permissions';

const StatusPage = () => import('./StatusPage.vue');

const routes = [
  {
    path: '/status',
    name: 'status',
    id: 'status',
    component: StatusPage,
    omitFromNav: true,
    meta: { requiresPermission: permissions.canViewStatusPage, titleExtension: 'general.status' },
  },
];

export default routes;
